import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';
import { FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const WhyMe = () => {
  const { t } = useLanguage();

  return (
    <Section id="why-me" bg="bg-brand-darker border-y border-brand-border/30">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        
        <div>
          <SectionHeading>{t.whyMe.heading}</SectionHeading>
          <p className="text-xl font-medium text-brand-accent mt-8 mb-4">
            {t.whyMe.statement}
          </p>
        </div>

        <div className="space-y-6">
          {t.whyMe.items.map((item, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex-shrink-0 mt-1">
                <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-brand-accent" />
              </div>
              <div>
                <h4 className="text-lg font-bold text-brand-textHeading">{item.title}</h4>
                <p className="text-brand-textMuted mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </Section>
  );
};

export default WhyMe;